export default {"src":"/_next/static/media/outbound.0eddf4ae.gif","height":480,"width":1019,"blurWidth":0,"blurHeight":0};